import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { OwlMascot } from "@/components/OwlMascot";

const ProtectedRoute = ({ children, teacherOnly = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-center">
          <div className="anim-float"><OwlMascot size={100} /></div>
          <div className="mt-4 text-slate-500 font-mono text-sm">Loading…</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (teacherOnly && user.role !== "teacher" && user.role !== "owner") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
